import React from 'react';

import { Box, IconButton, Modal, Typography } from '@mui/material';

import closeIcon from '../../../assets/close.svg';
import Player from '../Player';

interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  url: string;
  title?: string;
  isM3U8?: boolean;
}

export const VideoModal: React.FC<VideoModalProps> = ({
  open,
  onClose,
  url,
  title = "Video Player",
  isM3U8 = true,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="video-modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "25rem",
          height: "35rem",
          bgcolor: "background.paper",
          boxShadow: 10,
          borderRadius: 2,
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography sx={{ fontSize: 16, fontWeight: "900" }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, display: "flex" }}>
          {isM3U8 ? (
            <Player
              src={url}
              autoPlay
              muted={false}
            />
          ) : (
            <video
              width="100%"
              height="100%"
              controls
              style={{ objectFit: "contain" }}
            >
              <source src={url} type="video/mp4" />
            </video>
          )}
        </Box>
      </Box>
    </Modal>
  );
};
